import styled from 'styled-components';

import { SettingSmallText } from 'approot/activity-builder/settings/settings.style';
import { Box } from 'approot/shared/design-system/box/box.style';
import { red1, red8 } from 'approot/shared/styles/colours.style';
import { RichtextInlineEditor } from 'approot/shared/richtext/richtext.style';

type TeachingNotesDetailRichtextWrapperProps = {
  $error?: boolean;
};
export const TeachingNotesDetailRichtextWrapper = styled(Box).attrs({
  $marginBottom: 24,
})<TeachingNotesDetailRichtextWrapperProps>`
  ${({ $error }) =>
    $error &&
    `
    ${SettingSmallText} {
      color: ${red8};
    }
    ${RichtextInlineEditor} .ProseMirror {
      background-color: ${red1};
      border-color: ${red8};
      border-width: 2px;
    }
  `}
`;
